import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import RedeSocialSearchForm from './search-form.js'

const RedeSocialSearchModel = {
  nome: null
}

export default {
  mixins: [ActionsForm],
  name: 'CampanhaRedeSocialSearch',
  data () {
    return {
      data: RedeSocialSearchModel,
      form: RedeSocialSearchForm
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  methods: {
    onLoad () {
      this.onClearFilters()
    },
    onClearFilters () {
      Tools.SetFormDefaultValues(this.form)
      this.form.nome.value = null
      this.parentComponent.filters = null
      this.parentComponent.onLoad()
    },
    onValidateFilters () {
      let result = true
      Tools.SetValueToSave(this.form, this.data)
      return result
    },
    onFilter () {
      if (this.onValidateFilters()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/campaign/templates/components/search/search.js